import { render } from "./CarConfirmation.vue?vue&type=template&id=ab0b1974&scoped=true"
import script from "./CarConfirmation.vue?vue&type=script&lang=js"
export * from "./CarConfirmation.vue?vue&type=script&lang=js"

import "./CarConfirmation.vue?vue&type=style&index=0&id=ab0b1974&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0b1974"]])

export default __exports__